import { Card } from 'antd';
import type { CardProps } from 'antd';
import { neutral } from '@/theme';

type CardVariant = 'default' | 'highlight' | 'surface';

interface WisecureCardProps extends Omit<CardProps, 'variant'> {
  dsVariant?: CardVariant;
}

const variantStyles: Record<CardVariant, React.CSSProperties> = {
  default: {},
  highlight: {
    background: neutral[900],
    color: neutral[0],
  },
  surface: {
    background: neutral[50],
  },
};

export function WisecureCard({
  dsVariant = 'default',
  style,
  children,
  ...rest
}: WisecureCardProps) {
  return (
    <Card
      style={{
        borderRadius: 16,
        ...variantStyles[dsVariant],
        ...style,
      }}
      {...rest}
    >
      {children}
    </Card>
  );
}
